import React, { useState, useEffect } from "react";
import axiosConfig from "../Service/axiosConfig";
import { SettingNavbarComponent } from "../Components/navbar/settingsnav";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import DataTable from "react-data-table-component";
import Masters from "../Components/masters.json";
import { DeletePopupModal, PopupModal, FormParser } from "../Components";
import { BiSearch } from "react-icons/bi";
import Modal from "react-bootstrap/Modal";
import { FaHandHoldingHeart } from "react-icons/fa";
import useDebouncedValue from "../Utils/Debounce";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";

const DeliveryAgents = () => {
  const [Data, SetData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [LoadingButton, setLoadingButton] = useState();
  const [totalRows, setTotalRows] = useState(0);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [modalTitle, setModalTitle] = useState("");
  const [deliveryAgentid, setdeliveryAgentid] = useState();
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({});
  const [popupType, setpopupType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [Error, SetError] = useState();
  const [RowId, SetRowId] = useState();
  //const MastersModal = Masters.DeliveryAgents;
  const [MastersModal, setMastersModal] = useState(Masters.DeliveryAgents);
  const [deletePopupType, setDeletepopupType] = useState("");
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [search, SetSearch] = useState({
    search: "",
  });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const buildDeliveryAgentFormData = (payload) => {
    const multipartData = new FormData();
    const normalizeUrl = (url) => {
      if (typeof url !== "string") return url;
      return encodeURI(url.trim());
    };
    Object.entries(payload).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (key === "photo") {
        // Backend currently expects a URL/string for photo.
        // filemanager selection returns an object that contains image URL.
        if (typeof value === "string") {
          multipartData.append("photo", normalizeUrl(value));
          return;
        }
        if (value?.image) {
          multipartData.append("photo", normalizeUrl(value.image));
          return;
        }
      }
      multipartData.append(key, value);
    });
    return multipartData;
  };
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
  };
  const deliverAgentStore_columns = [
    {
      name: "ID",
      cell: (row, index) => (currentPage - 1) * RowPerPage + index + 1,
    },

    {
      name: "IS AVAILABLE",
      selector: "is_available",
      cell: (row) => (row.is_available ? "Yes" : "No"),
    },
    {
      name: "VEHICLE NUMBER",
      selector: "vehicle_number",
      sortable: true,
    },
    {
      name: "PHONE NUMBER",
      selector: "phone_number",
      sortable: true,
    },
    {
      name: "IS ACTIVE DELIVERY",
      selector: "is_active_delivery",
      cell: (row) => (row.is_active_delivery ? "Yes" : "No"),
    },
    {
      name: "FULL NAME",
      cell: (row) => row.user.full_name,
      sortable: true,
    },
    {
      name: "EMAIL",
      cell: (row) => row.user.email,
      sortable: true,
    },
    {
      name: "PHOTO",
      cell: (row) => {
        const photoUrl = row.photo || row.user?.photo;
        return photoUrl ? (
          <img
            src={photoUrl}
            alt={row.user?.full_name || "Delivery agent"}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        ) : (
          "-"
        );
      },
    },
    {
      name: "ACTIONS",
      width : "240px",
      selector: (row) => {
        const HandleEdit = async () => {
          setMastersModal(Masters.DeliveryAgents);
          setShow(true);
          deliveryAgentedit(row.id);
          setModalTitle("Edit DeliveryAgents");
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          await axiosConfig
            .delete(`/deliveryagent/delivery-agents/${id}/`)
            .then(() => {
              SetAlertDeletePopupType("error");
              setDeletepopupType("success");
              GetData();
            })
            .catch((error) => {
              setDeletepopupType("error");
              SetAlertDeletePopupType("error");
              console.log(error);
            });
        };
        const handleRevive = async () => {
          try {
            const response = await axiosConfig.post(
              `/deliveryagent/delivery-agents/${row.id}/revive/`
            );
            setpopupType("success");
            setMessage("Delivery Agent revived successfully");
            GetData();
          } catch (error) {
            console.log("Error While Reviving", error);
          }
        };
        const deliveryAgentedit = (id) => {
          axiosConfig
            .get(
              `/deliveryagent/delivery-agents/${id}/?fields_user=id,full_name,email,phone_number`
            )
            .then((res) => {
              console.log(res.data, "edit");
              let form_data = {
                ...res.data,
                full_name: res.data.user.full_name,
                email: res.data.user.email,
                phone_number: res.data?.phone_number
              };
              delete form_data.user;
              setFormData(form_data);
              setMessage("Record Updated Successfully");
              setdeliveryAgentid(id);
              setShow(true);
            })
            .catch((error) => {
              console.log(error);
            });
        };

        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="table-actions">
                  <button className="action-btn edit-btn" onClick={HandleEdit}>
                    <MdOutlineEdit /> Edit
                  </button>

                  <button className="action-btn delete-btn" onClick={DeleteAlert}>
                    <MdDeleteOutline /> Delete
                  </button>
                </div>
              </div>
            ) : (
              <>
                <FaHandHoldingHeart
                  className="dashboard-tabe-data-actions"
                  onClick={handleRevive}
                />
              </>
            )}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage, debouncedSearchTerm]);


  const formSubmit = async (FormData) => {
    console.log(FormData, "formdata");
    setLoadingButton(true);
    if (FormData.phone_number.length < 10) {
      setpopupType("error")
      SetError("Phone number should be 10 digits")
      setLoadingButton(false)
      return
    }
    if (FormData.vehicle_number.length < 10) {
      setpopupType("error")
      SetError("Vehicle number should be 10 digits")
      setLoadingButton(false)
      return
    }
    const payload = buildDeliveryAgentFormData(FormData);
    if (FormData.id) {
      await axiosConfig
        .patch(`/deliveryagent/delivery-agents/${FormData.id}/`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetData();
          setShow(false);
          setLoadingButton(false);
        })
        .catch((error) => {
          console.log(error);
          let error_message = error.response.data;
          Object.values(error_message)[0] &&
            SetError(Object.values(error_message)[0]);
          setpopupType("error");
        });
      setLoadingButton(false);
    } else {
      await axiosConfig
        .post("/deliveryagent/delivery-agents/", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetData();
          setShow(false);
          setLoadingButton(false);
        })
        .catch((error) => {
          console.log(error);
          let error_message = error.response.data;
          Object.values(error_message)[0] &&
            SetError(Object.values(error_message)[0]);
          setpopupType(error);
        });
      setLoadingButton(false);
    }
  };
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `/deliveryagent/delivery-agents/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get(
        `/deliveryagent/delivery-agents/?page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      SetData(responce.data.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClose = () => {
    setShow(false);
    SetError("");
    setpopupType("");
    setLoadingButton(false);
  };

  const handleShow = () => {
    setShow(true);
    setMastersModal(Masters.DeliveryAgents);
    setFormData({
      is_available: "",
      vehicle_number: "",
      phone_number: "",
      is_active_delivery: "",
      full_name: "",
      email: "",
      photo: "",
    });
    setModalTitle("DeliveryAgents");
  };

  return (
    <>
      <div className="child-sidenav">
        <SettingNavbarComponent />
        <div className="childnav-content">
          <div className="d-flex align-items-center">
            <div className="col-4 input-cat-with-icon">
              <span className="icon-product">
                <BiSearch />
              </span>
              <input
                type="text"
                className="input-control"
                placeholder="Search"
                name="search"
                value={search.search}
                onChange={HandleSearch}
              />
            </div>
            <div className="cat-button">
              <div className="btn" onClick={handleShow}>
                + Add New
              </div>
            </div>
          </div>
          <div className="table-responsive marginTop">
            <DataTable
              columns={deliverAgentStore_columns}
              data={Data}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={RowPerPage}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
              paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
              onChangeRowsPerPage={(RowsPerPageChange) =>
                setRowPerPage(RowsPerPageChange)
              }
              onSort={handleSort}
              fixedHeader
              subHeader
              customStyles={tableCustomStyles}
              progressPending={Loading}
              progressComponent={
                <div className="loader-container">
                  <img
                    src={require("../Components/FormParser/images/loader2.gif")}
                    alt="Loading..."
                  />
                </div>
              }
            />
          </div>
          <Modal
            size="xl"
            show={show}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                {modalTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormParser
                modelObject={MastersModal}
                formData={formData}
                formSubmit={formSubmit}
                error={Error}
                LoadingButton={LoadingButton}
                buttonTitle="Save"
              />
            </Modal.Body>
          </Modal>
          {popupType !== "" && (
            <PopupModal
              setpopupType={setpopupType}
              popupType={popupType}
              Navigation=""
              Message={message}
              setMessage={setMessage}
              error={Error}
            />
          )}
          {deletePopupType !== "" && (
            <DeletePopupModal
              setDeletepopupType={setDeletepopupType}
              deletePopupType={deletePopupType}
            />
          )}
        </div>
      </div>
    </>
  );
};

export { DeliveryAgents };
